import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboardSetup",
  initialState: {
    kidList: [],
    kidDevicesList: [],
    selectedKidId: null,
    dashboardLoader: true,
    setRulesData: [],
    slotData: null,
    allAppData: [],
    messageCountData: [],
    selectedDeviceData: null,
    latestActivityData: null,
    appData: []
  },
  reducers: {
    setKidList: (state, action) => {
      state.kidList = action?.payload
    },
    setSelectedKidId: (state, action) => {
      state.selectedKidId = action?.payload
    },
    setKidDevicesList: (state, action) => {
      state.kidDevicesList = action?.payload
    },
    setDashboardLoader: (state, action) => {
      state.dashboardLoader = action?.payload
    },
    setRulesData: (state, action) => {
      state.setRulesData = action?.payload
    },
    setSlotData: (state, action) => {
      state.slotData = action?.payload
    },
    setAllAppData: (state, action) => {
      state.allAppData = action?.payload
    },
    setMessageCountData: (state, action) => {
      state.messageCountData = action?.payload
    },
    setSelectedDeviceData: (state, action) => {
      state.selectedDeviceData = action?.payload
    },
    setLatestActivityData: (state, action) => {
      state.latestActivityData = action?.payload
    },
    setAppData: (state, action) => {
      state.appData = action?.payload
    },
    removeDashboardData: (state, action) => {
      switch (action?.payload) {
        case 'REMOVE_KID_LIST':
          state.kidList = []
          break;
        case 'RESET_KID_ID':
          state.selectedKidId = null;
          break;
        case 'SET_RULES_DATA':
          state.setRulesData = [];
          break;
        case 'RESET_SLOT_DATA':
          state.slotData = null;
          break;
        case 'CLEAR_ALL_APP_DATA': 
          state.allAppData = [];
          break;
        default: {
          state.kidList = []
          state.kidDevicesList = []
          state.selectedKidId = null
          state.dashboardLoader = true
          state.setRulesData = []
          state.slotData = null
          state.allAppData = []
          state.messageCountData = null
          state.selectedDeviceData = null
          state.latestActivityData = null
          state.appData = []
        }
      }
    },
    clearDashboard: (state, payload) => {
      state.kidList = []
      state.kidDevicesList = []
      state.selectedKidId = null
      state.dashboardLoader = true
      state.setRulesData = []
      state.slotData = null
      state.allAppData = []
      state.messageCountData = null
      state.selectedDeviceData = null
      state.latestActivityData = null
      state.appData = []
    }
  }
});


// this is for dispatch
export const {
  setKidList,
  setSelectedKidId,
  setKidDevicesList,
  removeDashboardData,
  clearDashboard,
  setDashboardLoader,
  setRulesData,
  setSlotData,
  setAllAppData,
  setMessageCountData,
  setSelectedDeviceData,
  setLatestActivityData,
  setAppData
} = dashboardSlice.actions;

// this is for configureStore
export default dashboardSlice.reducer;